import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { toggleModalDiagramDelete, diagramDelete } from '../../../redux/main/main.actions';
import { selectIsModalDiagramDeleteEnabled, selectModalDiagramDeleteData } from '../../../redux/main/main.selectors';

import { trackEvent } from '../../../lib/analytics';

import Modal from '../Modal/Modal';
import './ModalDiagramDelete.scss';

export const ModalDiagramDelete = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const isOpen = useSelector(selectIsModalDiagramDeleteEnabled);
    const modalData = useSelector(selectModalDiagramDeleteData);

    const [value, setValue] = useState(modalData?.diagram?.title || '');

    useEffect(() => {
        if (!modalData?.diagram?.title) return;

        if (value !== modalData?.diagram?.title) {
            setValue(modalData?.diagram?.title || '');
        }
        return () => { };
    }, [modalData]);

    const handleSave = () => {
        trackEvent('app_modal_diagram_delete_submit', {
            page: 'app',
            type: 'modals',
        });
        dispatch(diagramDelete(modalData?.diagram?.id));
        dispatch(toggleModalDiagramDelete(null));
    };

    const handleCancel = () => {
        dispatch(toggleModalDiagramDelete(null));
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-diagram-delete`}
            // modalClass={`modal-diagram-clone ${page}`}
            onCancel={handleCancel}
        >
            <div className="modal-content-header">{t('m_diagram_delete.header')}</div>
            <div className="modal-content-body">
                {/* <div className='description-text'>{`This will permanently delete ${value}. You won’t be able to restore it.`}</div> */}
                <div className='description-text'>{t('m_diagram_delete.desc_prefix')}<span className='text-title-bold'>{value}</span>.</div>
                <div className='buttons-wrap'>
                    <button className='button-second' onClick={() => handleCancel()}>{t('b.cancel')}</button>
                    <button onClick={() => handleSave()}>{t('b.delete')}</button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalDiagramDelete;
